import { styled, spacing, mq, Text } from '@thg-commerce/gravity-theme'
import { margin, Margin } from '@thg-commerce/gravity-theme/margin'
import { TextStyling } from '@thg-commerce/gravity-theme/typography/typography'
import {
  BreakpointKey,
  breakpointUtils,
} from '@thg-commerce/gravity-theme/breakpoints'
import { DrawFocus } from '@thg-commerce/gravity-elements'

import { Directions } from './types'

interface ContainerProps {
  directions: Directions
  condensed: boolean
}

export const Title = styled.h1<{ textStyle?: TextStyling; margin?: Margin }>`
  ${(props) =>
    Text(
      props.textStyle?.entry || 'large2',
      props.textStyle?.style || 'alternate',
    )}
  ${(props) =>
    margin(
      props.margin || {
        top: spacing(4),
        bottom: spacing(3),
      },
    )}
`

export const Container = styled.div<ContainerProps>`
  display: none;

  ${(props) =>
    props.directions.map(
      (direction, index) => `
        ${mq(
          props.theme.breakpointUtils.map,
          breakpointUtils.keys[index] as BreakpointKey,
        )} {
          flex-direction: ${direction};
        }
      `,
    )}

  ${(props) => mq(props.theme.breakpointUtils.map, 'md')} {
    ${DrawFocus()}
    display: flex;
    margin: -2px;
    text-decoration: none;
  }
`

export const ImageContainer = styled.div`
  margin: ${spacing(2)} 0 ${spacing(4)};
`
